import type { SceneObject } from "../modeling/types.ts";
import { mergeModifierStack } from "../viewport/modifiers/evaluation.ts";
import type {
  Collection,
  CollectionCutterRef,
  ModifierOverride,
} from "./storeTypes.ts";

export function resolveCollectionCutterRef(
  collection: Collection,
  sceneObjects: ReadonlyMap<string, SceneObject>,
  modifierOverrides: ReadonlyMap<string, readonly ModifierOverride[]>,
): CollectionCutterRef | null {
  if (collection.cutterRef) return collection.cutterRef;

  const memberIdByName = new Map<string, string>();
  for (const objectId of collection.objectIds) {
    const object = sceneObjects.get(objectId);
    if (object) memberIdByName.set(object.name, objectId);
  }

  for (const hostObjectId of collection.objectIds) {
    const stack = mergeModifierStack([], modifierOverrides.get(hostObjectId));
    const cutterObjectIds = new Set<string>();
    for (const modifier of stack) {
      if (modifier.kind !== "boolean" || !modifier.targetObjectName) {
        continue;
      }
      const cutterObjectId = memberIdByName.get(modifier.targetObjectName);
      if (cutterObjectId && cutterObjectId !== hostObjectId) {
        cutterObjectIds.add(cutterObjectId);
      }
    }
    if (cutterObjectIds.size > 0) {
      return { hostObjectId, cutterObjectIds };
    }
  }

  return null;
}

export function findCutterCollectionIdForObject(
  collections: ReadonlyMap<string, Collection>,
  sceneObjects: ReadonlyMap<string, SceneObject>,
  modifierOverrides: ReadonlyMap<string, readonly ModifierOverride[]>,
  objectId: string,
): string | null {
  for (const [collectionId, collection] of collections) {
    if (!collection.objectIds.has(objectId)) continue;
    if (
      resolveCollectionCutterRef(collection, sceneObjects, modifierOverrides)
    ) {
      return collectionId;
    }
  }
  return null;
}
